import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class HttpsService {

    constructor(private http: HttpClient, private auth: AuthService) { }

    getToken() {
        return localStorage.getItem('core_spa_user_token');
    }

    headers = new HttpHeaders({
        'Content-Type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: "Bearer " + this.getToken()
    });





    options = { headers: this.headers, withCredintials: true };



    post(serviceName: string, data: any) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.post(url, data, this.options);
    }

    get(serviceName: string) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.get(url, this.options);
    }

    put(serviceName: string, data: any) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.put(url, data, this.options);
    }

    delete(serviceName: string) {
        const url = environment.apiBaseUrl + serviceName;
        return this.http.delete(url, this.options);
    }

}
